import { useLazyQuery } from '@apollo/client';

import { pendingReturnProductsQuery } from './gql';
import { IQueryResult, IPendingReturnProductVariables } from './interfaces';

export const usePendingReturnProductsGql = () => {
  const [runPendingReturnProductsGql, { loading, data, error }] = useLazyQuery<IQueryResult, IPendingReturnProductVariables>(
    pendingReturnProductsQuery,
    {
      context: {
        headers: {
          userFunctionKey: '3416a75f4cea9109507cacd8e2f2aefc'
        }
      },
      fetchPolicy: 'network-only'
    }
  );

  return {
    runPendingReturnProductsGql,
    loadingPendingReturnProducts: loading,
    dataPendingReturnProducts: data?.pendingReturnProducts || [],
    errorPendingReturnProducts: error
  };
};
